import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  Col,
  Container,
  Row,
} from "reactstrap";
import { MdOutlineCheck } from "react-icons/md";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";

import insureshieldContent from "@/data/insureshield.json";
import { routes } from "@/utils/routes";
import classes from "@/styles/insureshield/insureshield-main.module.css";
import { insureShieldImg1 } from "@/utils/images";
import { useIsMobile } from "@/hooks/useIsMobile";

const InsureshieldMain = () => {
  const router = useRouter();
  const [open, setOpen] = useState("1");
  const isMobile = useIsMobile();

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };
  return (
    <main className={classes.container}>
      <section className={isMobile ? "" : "my-5"}>
        <Container className="position-relative">
          <Image
            src="https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/background-image-min.jpg"
            alt="Insure Shield Banner"
            height={350}
            width={1260}
            className={isMobile ? "img-fluid" : classes.heroImg}
          />
          <div className={classes.floatDiv}>
            <h2>{insureshieldContent.title1}</h2>
            <p>{insureshieldContent.para1}</p>
          </div>
        </Container>
      </section>
      <section className="my-5">
        <Container className="text-center">
          <Link
            href={`${routes.insureshield}/terms`}
            className={`btn btn-outline ${classes.termsBtn}`}
          >
            Terms And Conditions
          </Link>
        </Container>
      </section>
      <section className="my-5">
        <Container>
          <h2 className="text-center">{insureshieldContent.title2}</h2>
          <Row className="my-5">
            {insureshieldContent.stats?.map((s, i) => (
              <Col
                xs={12}
                md={4}
                className={
                  i + 1 !== insureshieldContent.stats.length
                    ? classes.borderCard
                    : "text-center"
                }
                key={i}
              >
                <h2 className="text-parGreen h1">{s.title}</h2>
                <p className="w-75 mx-auto text-grey">
                  {s.desc}
                  <sup>{s.termsNumber}</sup>
                </p>
              </Col>
            ))}
          </Row>
          <p
            className="my-5 text-center"
            dangerouslySetInnerHTML={{ __html: insureshieldContent.para2 }}
          />
        </Container>
      </section>
      <section className="my-5">
        <Container>
          <h3 className="text-center">{insureshieldContent.title3}</h3>
          <p className="text-center">{insureshieldContent.para3}</p>
        </Container>
      </section>
      <section className="my-5">
        <Container>
          <Row>
            <Col className="mb-4" xs={12} lg={6}>
              <Image
                className={`${classes.gr1Col1Img1} img-fluid`}
                src={insureShieldImg1}
                alt="Laptop"
                height={500}
                width={500}
              />
            </Col>
            <Col xs={12} lg={6}>
              <div>
                {insureshieldContent.features?.map((f, i) => (
                  <div className="d-flex gap-3 align-items-top mb-3" key={i}>
                    <Image src={f.img} alt={f.alt} height={50} width={50} />
                    <div>
                      <h5 className="text-grey">{f.title}</h5>
                      <p className="text-grey">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="my-5">
        <Container>
          <h3 className="text-center fw-bold">{insureshieldContent.title4}</h3>
          <p className="text-center">{insureshieldContent.para4}</p>
        </Container>
      </section>
      <section className="my-5">
        <Container className="pt-5 mt-5">
          <Card className={classes.imgCard}>
            <Image
              className={classes.cardImg}
              height={150}
              width={150}
              src={insureshieldContent.image1}
              alt="Insta Quote"
            />
            <h4 className="text-center text-grey">
              {insureshieldContent.title5}
            </h4>
            <ul className={classes.insureUl}>
              {insureshieldContent.benefits?.map((b, i) => (
                <li key={i}>
                  <div>
                    <MdOutlineCheck className={classes.liIco} size={25} />
                  </div>
                  <p>
                    {b.para}
                    {b.sup && <sup>{b.sup}</sup>}
                  </p>
                </li>
              ))}
            </ul>
          </Card>
        </Container>
      </section>
      <section className="my-5">
        <Container>
          <h3 className="my-3">{insureshieldContent.faqTitle}</h3>
          {/*@ts-ignore*/}
          <Accordion open={open} toggle={toggle}>
            {insureshieldContent.faqs?.map((f, i) => {
              return (
                <AccordionItem key={i}>
                  <AccordionHeader targetId={(i + 1).toString()}>
                    {f.title}
                  </AccordionHeader>
                  <AccordionBody accordionId={(i + 1).toString()}>
                    <div dangerouslySetInnerHTML={{ __html: f.desc }} />
                  </AccordionBody>
                </AccordionItem>
              );
            })}
          </Accordion>
        </Container>
      </section>
      <section className="my-5">
        <Container>
          <p dangerouslySetInnerHTML={{ __html: insureshieldContent.para5 }} />
          <p>{insureshieldContent.para6}</p>
        </Container>
      </section>
    </main>
  );
};

export default InsureshieldMain;
